/* PLTX2 Reviews Vertical Feed — v3
   List-card redesign + colorway merge.
   - Feed merges reviews from every product in the group (colorways = one
     product) via k-way merge over per-product cursors — the backend API
     stays per-product and untouched.
   - Summary header combines the group's rating summaries (weighted avg +
     summed distribution) and drives the distribution panel.
   - Card click opens a review detail modal (fullscreen mobile / split
     popup desktop). Voice players, thumbs, admin replies kept. */
(function() {
  'use strict';

  var section = document.querySelector('.pltx2-vertical');
  if (!section) return;

  var apiBase = section.getAttribute('data-api-base') || '';
  var currentProductId = section.getAttribute('data-product-id') || '';
  var perPage = parseInt(section.getAttribute('data-per-page') || '10', 10);

  /* === Product group (colorway siblings) — emitted by pltx2-review-group === */
  var group = { ids: [currentProductId], products: {} };
  try {
    var cfgEl = section.querySelector('script[data-pltx2-review-group]');
    if (cfgEl) {
      var parsed = JSON.parse(cfgEl.textContent);
      if (parsed && parsed.ids && parsed.ids.length) group = parsed;
    }
  } catch (e) { console.warn('[pltx2-vertical] group config parse failed', e); }
  group.ids = group.ids.map(function(id) { return String(id); });

  /* === Elements === */
  var listEl = document.getElementById('pltx2ReviewsList');
  var skelEl = document.getElementById('pltx2Skeleton');
  var emptyEl = document.getElementById('pltx2Empty');
  var emptyRichHTML = emptyEl ? emptyEl.innerHTML : '';
  var loadMoreWrap = document.getElementById('pltx2LoadMore');
  var loadBtn = document.getElementById('pltx2LoadBtn');

  var headerEl = document.getElementById('pltx2VHeader');
  var distToggle = document.getElementById('pltx2DistToggle');
  var distPanel = document.getElementById('pltx2DistPanel');
  var distRowsEl = document.getElementById('pltx2DistRows');
  var distAvgNum = document.getElementById('pltx2DistAvgNum');
  var vStars = document.getElementById('pltx2VStars');
  var vAvg = document.getElementById('pltx2VAvg');

  var sortWrap = document.getElementById('pltx2SortWrap');
  var sortBtn = document.getElementById('pltx2SortBtn');
  var sortMenu = document.getElementById('pltx2SortMenu');

  var rmodal = document.getElementById('pltx2Rmodal');
  var rmodalImg = document.getElementById('pltx2RmodalImg');
  var rmodalCounter = document.getElementById('pltx2RmodalCounter');
  var rmodalName = document.getElementById('pltx2RmodalName');
  var rmodalVerified = document.getElementById('pltx2RmodalVerified');
  var rmodalStars = document.getElementById('pltx2RmodalStars');
  var rmodalDate = document.getElementById('pltx2RmodalDate');
  var rmodalBody = document.getElementById('pltx2RmodalBody');
  var rmodalProduct = document.getElementById('pltx2RmodalProduct');

  /* === State === */
  var state = {
    sort: 'newest',
    filter: 'all',   /* all | photo | voice | 5star | 4star */
    loading: false
  };
  var sources = [];        /* [{id, cursor, buffer[], done}] */
  var reviewById = {};     /* id → review (for the modal) */
  var mustById = {};       /* carousel reviews — kept apart: cleanupCards() resets reviewById on every list reload */

  var GOLD = '#F5B800', GREY = '#E0E0E0';

  /* === Fingerprint for reactions === */
  function getFingerprint() {
    var fp;
    try { fp = localStorage.getItem('pltx_fp'); } catch (e) {}
    if (fp) return fp;
    fp = 'fp_' + Date.now().toString(36) + '_' + Math.random().toString(36).substr(2, 9);
    try { localStorage.setItem('pltx_fp', fp); } catch (e) {}
    return fp;
  }

  /* === Helpers === */
  function esc(s) {
    if (!s) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* The date a review was WRITTEN (createdAt), not when it was approved. The
     admin panel sets approvedAt = createdAt on approval, so the backend's
     approvedAt ordering (sortKeyDate below) follows the written date too. */
  function fmtDate(r) {
    var d = new Date(r.createdAt || r.approvedAt || 0);
    if (isNaN(d.getTime()) || d.getTime() === 0) return '';
    return d.toLocaleDateString(document.documentElement.lang || 'he-IL');
  }

  function fmtDuration(ms) {
    var sec = Math.floor((ms || 0) / 1000);
    var m = Math.floor(sec / 60);
    var s = sec % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  /* Review body → HTML. ==...== renders as a marker highlight
     (edit the review body in the admin panel to place the marker). */
  function bodyHtml(r) {
    var title = r.title ? '<strong>' + esc(r.title) + '</strong>\n' : '';
    var t = esc(r.body || '');
    t = t.replace(/==([^=\n][^=]{0,300}?)==/g, '<mark class="pltx2-highlight">$1</mark>');
    return title + t;
  }

  function starsHtml(rating, px) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<svg width="' + px + '" height="' + px + '" viewBox="0 0 24 24" aria-hidden="true"><use href="#pltx2-star" fill="' + (i <= rating ? GOLD : GREY) + '"/></svg>';
    }
    return out;
  }

  /* === Voice player HTML (unique feature — kept) === */
  function renderVoicePlayer(voiceUrl, waveform, durationMs) {
    var bars = '';
    var wf = waveform || [];
    if (wf.length > 0) {
      var count = wf.length;
      bars = '<svg class="pltx2-voice__bars" viewBox="0 0 ' + (count * 3) + ' 32" preserveAspectRatio="none" aria-hidden="true">';
      for (var i = 0; i < count; i++) {
        var h = Math.max(4, Math.min(26, wf[i] * 22 + 4));
        var y = (32 - h) / 2;
        bars += '<rect class="pltx2-voice__bar" x="' + (i * 3) + '" y="' + y + '" width="1.5" height="' + h + '" rx="1" fill="#D3D3D3"/>';
      }
      bars += '</svg>';
    } else {
      bars = '<svg class="pltx2-voice__bars" viewBox="0 0 150 32" preserveAspectRatio="none" aria-hidden="true">';
      for (var j = 0; j < 50; j++) {
        var seed = ((j * 7) % 17) + 2;
        var seed2 = (j * 13) % 11;
        var bh = Math.min(26, seed + seed2 * 0.9 + 4);
        var by = (32 - bh) / 2;
        bars += '<rect class="pltx2-voice__bar" x="' + (j * 3) + '" y="' + by + '" width="1.5" height="' + bh + '" rx="1" fill="#D3D3D3"/>';
      }
      bars += '</svg>';
    }
    return '<div class="pltx2-voice" data-voice-url="' + esc(voiceUrl) + '" data-duration-ms="' + (durationMs || 0) + '">' +
      '<span class="pltx2-voice__time">' + fmtDuration(durationMs) + '</span>' +
      '<div class="pltx2-voice__track" role="slider" tabindex="0" aria-label="Audio progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' + bars + '</div>' +
      '<button class="pltx2-voice__play" aria-label="' + esc(pltxT('pltx2.js.k060', 'נגן הקלטה קולית')) + '">' +
      '<svg class="pltx2-voice__icon-play" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><use href="#pltx2-play"/></svg>' +
      '<svg class="pltx2-voice__icon-pause" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style="display:none"><use href="#pltx2-pause"/></svg>' +
      '</button></div>';
  }

  function voicesHtml(r) {
    var recordings = r.voiceRecordings || [];
    if (recordings.length > 1) {
      var html = '<div class="pltx2-card__voices"><div class="pltx2-card__voices-scroll">';
      for (var vi = 0; vi < recordings.length; vi++) {
        html += renderVoicePlayer(recordings[vi].voiceUrl, recordings[vi].waveform, recordings[vi].durationMs);
      }
      return html + '</div></div>';
    }
    if (recordings.length === 1) {
      return '<div class="pltx2-card__voices">' + renderVoicePlayer(recordings[0].voiceUrl, recordings[0].waveform, recordings[0].durationMs) + '</div>';
    }
    if (r.voiceUrl) {
      return '<div class="pltx2-card__voices">' + renderVoicePlayer(r.voiceUrl, r.voiceWaveform, r.voiceDurationMs) + '</div>';
    }
    return '';
  }

  function thumbsHtml(r) {
    var reactions = r.reactions || {};
    var up = reactions['👍'] || 0;
    var down = reactions['👎'] || 0;
    return '<div class="pltx2-card__footer"><div class="pltx2-card__reactions">' +
      '<button class="pltx2-card__thumb" data-emoji="👍" data-review-id="' + (r.id || '') + '" aria-label="' + esc(pltxT('pltx2.js.k048', 'מועיל')) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><use href="#pltx2-thumb-up"/></svg><span class="pltx2-card__thumb-count">' + up + '</span></button>' +
      '<button class="pltx2-card__thumb" data-emoji="👎" data-review-id="' + (r.id || '') + '" aria-label="' + esc(pltxT('pltx2.js.k039', 'לא מועיל')) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><use href="#pltx2-thumb-down"/></svg><span class="pltx2-card__thumb-count">' + down + '</span></button>' +
      '</div></div>';
  }

  function replyHtml(r) {
    if (!r.adminReply || !r.adminReply.body) return '';
    return '<div class="pltx2-card__reply">' +
      '<div class="pltx2-card__reply-head"><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21 6h-2v9H7v2c0 .55.45 1 1 1h10l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/></svg>' + pltxT('pltx2.js.k093', 'תגובת PILATIX') + '</div>' +
      '<div class="pltx2-card__reply-body">' + esc(r.adminReply.body) + '</div>' +
    '</div>';
  }

  /* "צבע ורוד" under the product — the three colours share one feed, so this is how a
     reviewer's colour shows. Value comes from the cart_color_names metafield. */
  function colorLine(p, cls) {
    var c = (p && p.color ? String(p.color) : '').trim();
    if (!c) return '';
    var label = c.indexOf('צבע') === -1 ? (section.getAttribute('data-color-label') || '') + ' ' + c : c;
    return '<span class="' + cls + '">' + esc(label.trim()) + '</span>';
  }

  function productChipHtml(r) {
    var p = group.products[String(r._pid)] || group.products[String(currentProductId)];
    if (!p) return '';
    var img = p.image ? '<img class="pltx2-card__product-img" src="' + esc(p.image) + '" alt="" width="50" height="50" loading="lazy">' : '';
    return '<a class="pltx2-card__product" href="' + esc(p.url) + '">' + img +
      '<span class="pltx2-card__product-text"><span class="pltx2-card__product-name">' + esc(p.title) + '</span>' +
      colorLine(p, 'pltx2-card__product-color') + '</span></a>';
  }

  /* === Card renderer === */
  function renderCard(r) {
    var name = esc(r.reviewerName || r.name || pltxT('pltx2.js.k011', 'אנונימי'));
    var verified = r.isVerifiedPurchase
      ? '<span class="pltx2-card__verified"><svg width="14" height="14" viewBox="0 0 22 22" aria-hidden="true"><use href="#pltx2-verified-cc"/></svg><span class="pltx2-card__verified-text">' + pltxT('pltx2.js.k046', 'מאומת') + '</span></span>'
      : '';
    var photo = (r.photos && r.photos.length > 0)
      ? '<div class="pltx2-card__media pltx2-protect"><img draggable="false" src="' + esc(r.photos[0]) + '" alt="' + pltxT('pltx2.js.k094', 'תמונת ביקורת של ') + '' + name + '" loading="lazy"></div>'
      : '';

    return '<article class="pltx2-card' + (photo ? '' : ' pltx2-card--noimg') + '" data-review-id="' + (r.id || '') + '">' +
      '<div class="pltx2-card__main">' +
        '<div class="pltx2-card__titlerow">' +
          '<button class="pltx2-card__name pltx2-card__open" data-review-id="' + (r.id || '') + '" aria-label="' + pltxT('pltx2.js.k018', 'ביקורת מלאה מאת ') + '' + name + '">' + name + '</button>' +
          verified +
        '</div>' +
        '<div class="pltx2-card__time">' + fmtDate(r) + '</div>' +
        '<div class="pltx2-card__stars" role="img" aria-label="' + r.rating + '' + pltxT('pltx2.js.k004', ' מתוך 5 כוכבים') + '">' + starsHtml(r.rating, 14) + '</div>' +
        '<div class="pltx2-card__text" dir="auto">' + bodyHtml(r) + '</div>' +
        voicesHtml(r) +
        thumbsHtml(r) +
        replyHtml(r) +
      '</div>' +
      photo +
      productChipHtml(r) +
    '</article>';
  }

  /* === K-way merged fetching over the product group === */
  function resetSources() {
    sources = group.ids.map(function(id) {
      return { id: id, cursor: null, buffer: [], done: false };
    });
  }
  resetSources();

  /* Must mirror the backend orderBy(approvedAt) for the k-way merge — keep. */
  function sortKeyDate(r) {
    return r.approvedAt || r.createdAt || '';
  }
  function reactionSum(r) {
    var t = 0, re = r.reactions || {};
    for (var k in re) { if (re.hasOwnProperty(k)) t += (re[k] || 0); }
    return t;
  }
  /* Comparators mirror the backend orderBy chains so per-source order is
     preserved across the merge. Return >0 when a should come FIRST. */
  function better(a, b) {
    var s = state.sort;
    if (s === 'rating_high') {
      if (a.rating !== b.rating) return a.rating > b.rating;
      return sortKeyDate(a) > sortKeyDate(b);
    }
    if (s === 'rating_low') {
      if (a.rating !== b.rating) return a.rating < b.rating;
      return sortKeyDate(a) > sortKeyDate(b);
    }
    if (s === 'helpful') {
      var ra = reactionSum(a), rb = reactionSum(b);
      if (ra !== rb) return ra > rb;
      return sortKeyDate(a) > sortKeyDate(b);
    }
    /* newest = pinned first, then date (matches backend) */
    var pa = a.isPinned ? 1 : 0, pb = b.isPinned ? 1 : 0;
    if (pa !== pb) return pa > pb;
    return sortKeyDate(a) > sortKeyDate(b);
  }

  function fetchSourcePage(src) {
    var url = apiBase + '/api/reviews/product/' + src.id +
      '?limit=' + perPage + '&sort=' + state.sort;
    if (state.filter !== 'all') url += '&filter=' + state.filter;
    if (src.cursor) url += '&cursor=' + encodeURIComponent(src.cursor);
    return fetch(url)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (!data || data.error) { src.done = true; return; }
        var reviews = data.reviews || [];
        for (var i = 0; i < reviews.length; i++) {
          reviews[i]._pid = src.id;
          src.buffer.push(reviews[i]);
        }
        src.cursor = data.nextCursor || null;
        if (!data.nextCursor) src.done = true;
      })
      .catch(function(err) {
        console.error('[pltx2-vertical] fetch error (' + src.id + '):', err);
        src.done = true;
      });
  }

  function refillEmpties() {
    var pending = [];
    for (var i = 0; i < sources.length; i++) {
      var s = sources[i];
      if (!s.done && s.buffer.length === 0) pending.push(fetchSourcePage(s));
    }
    return pending.length ? Promise.all(pending) : Promise.resolve();
  }

  /* Pull n merged reviews. Bounded refill rounds so sparse client-side
     filters (photo/voice) can't hammer the API in one take. */
  function takeMerged(n, rounds) {
    if (rounds === undefined) rounds = 4;
    var out = [];
    function step() {
      while (out.length < n) {
        var best = null;
        for (var i = 0; i < sources.length; i++) {
          var s = sources[i];
          if (!s.buffer.length) continue;
          if (!best || better(s.buffer[0], best.buffer[0])) best = s;
        }
        if (!best) break;
        out.push(best.buffer.shift());
      }
      if (out.length >= n) return Promise.resolve(out);
      var anyRefillable = sources.some(function(s) { return !s.done && s.buffer.length === 0; });
      if (!anyRefillable || rounds <= 0) return Promise.resolve(out);
      rounds--;
      return refillEmpties().then(step);
    }
    return refillEmpties().then(step);
  }

  function hasMoreMerged() {
    return sources.some(function(s) { return s.buffer.length > 0 || !s.done; });
  }

  /* === Load a page into the list === */
  var filterLabels = { photo: pltxT('pltx2.js.k075', 'עם תמונות'), voice: pltxT('pltx2.js.k074', 'עם הקלטות'), '5star': pltxT('pltx2.js.k073', 'עם 5 כוכבים'), '4star': pltxT('pltx2.js.k072', 'עם 4 כוכבים') };

  function loadPage(append) {
    if (state.loading) return Promise.resolve();
    state.loading = true;

    if (!append) {
      resetSources();
      var currentH = listEl.offsetHeight;
      if (currentH > 50) listEl.style.minHeight = currentH + 'px';
      listEl.classList.add('pltx2-vertical__list--loading');
    }

    /* first default page: the pinned reviews (shown in the carousel) come first and are
       dropped below — fetch that many extra so the page still shows perPage reviews */
    var extra = (!append && mustOn && state.sort === 'newest' && state.filter === 'all') ? Object.keys(mustIds).length : 0;
    return takeMerged(perPage + extra)
      .then(function(reviews) {
        if (!append) {
          cleanupCards();
          listEl.innerHTML = '';
        }
        if (mustOn && state.sort === 'newest' && state.filter === 'all') {
          reviews = reviews.filter(function(r) { return !mustIds[r.id]; });
        }
        for (var i = 0; i < reviews.length; i++) reviewById[reviews[i].id] = reviews[i];

        var frag = document.createDocumentFragment();
        var temp = document.createElement('div');
        temp.innerHTML = reviews.map(function(r) { return renderCard(r); }).join('');
        while (temp.firstChild) frag.appendChild(temp.firstChild);
        listEl.appendChild(frag);

        skelEl.style.display = 'none';
        listEl.style.display = '';
        listEl.classList.remove('pltx2-vertical__list--loading');
        requestAnimationFrame(function() { listEl.style.minHeight = ''; });

        if (reviews.length === 0 && !append) {
          var filterName = filterLabels[state.filter] || '';
          emptyEl.innerHTML = filterName ? '<p>' + pltxT('pltx2.js.k008', 'אין ביקורות ') + '' + filterName + '</p>' : emptyRichHTML;
          emptyEl.style.display = '';
        } else {
          emptyEl.style.display = 'none';
        }
        loadMoreWrap.style.display = hasMoreMerged() ? '' : 'none';
        animateCards();
      })
      .catch(function(err) {
        console.error('[pltx2-vertical] load error:', err);
        skelEl.style.display = 'none';
        listEl.style.display = '';
        listEl.classList.remove('pltx2-vertical__list--loading');
        listEl.style.minHeight = '';
        if (!append) {
          cleanupCards();
          listEl.innerHTML = '';
          emptyEl.innerHTML = '<p>' + pltxT('pltx2.js.k086', 'שגיאה בטעינת ביקורות. נסו שוב.') + '</p>';
          emptyEl.style.display = '';
        }
      })
      .finally(function() { state.loading = false; });
  }

  /* === Combined summary (weighted avg + summed distribution) === */
  function fetchSummaries() {
    if (!apiBase) return;
    Promise.all(group.ids.map(function(id) {
      return fetch(apiBase + '/api/reviews/summary/' + id)
        .then(function(r) { return r.json(); })
        .catch(function() { return null; });
    })).then(function(all) {
      var total = 0, weighted = 0;
      var dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      for (var i = 0; i < all.length; i++) {
        var s = all[i];
        if (!s || s.error) continue;
        var c = s.totalCount || 0;
        total += c;
        weighted += (parseFloat(s.averageRating) || 0) * c;
        var d = s.distribution || {};
        for (var star = 1; star <= 5; star++) dist[star] += (d[star] || 0);
      }
      var avg = total > 0 ? weighted / total : 0;
      updateHeaderSummary(avg, total, dist);
    });
  }

  function updateHeaderSummary(avg, total, dist) {
    if (vAvg) vAvg.textContent = total > 0 ? avg.toFixed(1) : '';
    if (distAvgNum) distAvgNum.textContent = avg.toFixed(1);

    /* header stars: full + fractional clip fill */
    if (vStars) {
      var svgs = vStars.querySelectorAll('svg');
      var floor = Math.floor(avg);
      var frac = avg - floor;
      for (var i = 0; i < svgs.length; i++) {
        var starNum = i + 1;
        if (starNum <= floor) {
          var use = svgs[i].querySelector('use');
          if (use) use.setAttribute('fill', GOLD);
        } else if (starNum === floor + 1 && frac > 0.05) {
          var pct = Math.round(frac * 24);
          var clipId = 'pltx2-vc-' + starNum;
          svgs[i].innerHTML = '<defs><clipPath id="' + clipId + '"><rect x="' + (24 - pct) + '" y="0" width="' + pct + '" height="24"/></clipPath></defs>' +
            '<use href="#pltx2-star" fill="' + GREY + '"/>' +
            '<use href="#pltx2-star" fill="' + GOLD + '" clip-path="url(#' + clipId + ')"/>';
        }
      }
      vStars.setAttribute('aria-label', avg.toFixed(1) + pltxT('pltx2.js.k003', ' מתוך 5'));
    }

    /* distribution rows */
    if (distRowsEl) {
      var rows = distRowsEl.querySelectorAll('.pltx2-vertical__dist-row');
      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        var starVal = parseInt(row.getAttribute('data-stars'), 10);
        var count = dist[starVal] || 0;
        var pct = total > 0 ? count / total : 0;
        var fill = row.querySelector('[data-fill]');
        if (fill) fill.style.setProperty('--pltx2-fill', String(Math.max(pct, count > 0 ? 0.015 : 0)));
        var num = row.querySelector('[data-count]');
        if (num) num.textContent = '(' + count.toLocaleString() + ')';
        /* only 5★/4★ rating filters exist server-side */
        var filterable = count > 0 && (starVal === 5 || starVal === 4);
        if (filterable) row.removeAttribute('disabled');
        else row.setAttribute('disabled', '');
      }
    }
  }

  /* === Card pop-in (persistent observer) === */
  var cardObserver = null;
  var loadMoreObserver = null;

  function ensureCardObserver() {
    if (cardObserver) return cardObserver;
    if (!('IntersectionObserver' in window)) return null;
    cardObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var card = e.target;
          var pending = card.parentElement.querySelectorAll('.pltx2-card:not(.pltx2-card--visible)');
          var idx = 0;
          for (var i = 0; i < pending.length; i++) {
            if (pending[i] === card) { idx = i; break; }
          }
          setTimeout(function() { card.classList.add('pltx2-card--visible'); }, idx * 80);
          cardObserver.unobserve(card);
        }
      });
    }, { rootMargin: '40px', threshold: 0.05 });
    return cardObserver;
  }

  function ensureLoadMoreObserver() {
    if (loadMoreObserver) return loadMoreObserver;
    if (!('IntersectionObserver' in window)) return null;
    loadMoreObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('pltx2-vertical__load-more--visible');
          loadMoreObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    return loadMoreObserver;
  }

  function animateCards() {
    var cards = listEl.querySelectorAll('.pltx2-card:not(.pltx2-card--visible)');
    var obs = ensureCardObserver();
    if (!obs) {
      cards.forEach(function(c) { c.classList.add('pltx2-card--visible'); });
      return;
    }
    cards.forEach(function(c) { obs.observe(c); });

    if (loadMoreWrap && !loadMoreWrap.classList.contains('pltx2-vertical__load-more--visible')) {
      var lmObs = ensureLoadMoreObserver();
      if (lmObs) lmObs.observe(loadMoreWrap);
    }
  }

  /* === Voice player engine (audio on DOM nodes, single drag pair) === */
  var activeAudio = null;
  var activePlayer = null;
  var activeDragPlayer = null;

  function voiceGetBars(playerEl) { return playerEl.querySelectorAll('.pltx2-voice__bar'); }

  function voiceSetState(playerEl, s) {
    playerEl.classList.remove('pltx2-voice--playing', 'pltx2-voice--loading');
    if (s === 'playing') playerEl.classList.add('pltx2-voice--playing');
    else if (s === 'loading') playerEl.classList.add('pltx2-voice--loading');
    if (s === 'playing' || s === 'paused') {
      var btn = playerEl.querySelector('.pltx2-voice__play');
      if (btn) { btn.style.transform = 'scale(1.15)'; setTimeout(function() { btn.style.transform = ''; }, 150); }
    }
  }

  function voiceUpdateProgress(playerEl, pct) {
    var bars = voiceGetBars(playerEl);
    var playedCount = Math.floor(pct * bars.length);
    for (var i = 0; i < bars.length; i++) {
      bars[i].setAttribute('fill', i >= (bars.length - playedCount) ? '#7B8280' : '#D3D3D3');
    }
  }

  function voiceUpdateTime(playerEl, sec) {
    var timeEl = playerEl.querySelector('.pltx2-voice__time');
    if (!timeEl) return;
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    timeEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
  }

  function voiceEnsureAudio(playerEl) {
    if (playerEl._audio) return playerEl._audio;
    var voiceUrl = playerEl.getAttribute('data-voice-url');
    var audio = new Audio(voiceUrl);
    audio.preload = 'auto';
    playerEl._audio = audio;
    playerEl._voiceLoading = false;

    audio.addEventListener('timeupdate', function() {
      if (audio.duration && !activeDragPlayer) {
        voiceUpdateProgress(playerEl, audio.currentTime / audio.duration);
        voiceUpdateTime(playerEl, audio.currentTime);
      }
    });
    audio.addEventListener('canplay', function() {
      if (playerEl._voiceLoading) {
        playerEl._voiceLoading = false;
        voiceSetState(playerEl, 'playing');
        if (audio.duration && audio.duration !== Infinity) {
          playerEl.setAttribute('data-duration-ms', Math.round(audio.duration * 1000));
        }
      }
    });
    audio.addEventListener('ended', function() {
      var dur = parseInt(playerEl.getAttribute('data-duration-ms') || '0', 10);
      voiceSetState(playerEl, 'paused');
      voiceUpdateProgress(playerEl, 0);
      voiceUpdateTime(playerEl, dur / 1000);
      activeAudio = null;
      activePlayer = null;
    });
    audio.addEventListener('error', function() {
      playerEl._voiceLoading = false;
      voiceSetState(playerEl, 'paused');
      console.error('[pltx2-voice] Audio load failed:', voiceUrl);
    });
    return audio;
  }

  /* RTL seek: play button on the RIGHT, audio starts from the RIGHT. */
  function voiceSeekFromX(playerEl, clientX) {
    var track = playerEl.querySelector('.pltx2-voice__track');
    if (!track) return;
    var audio = voiceEnsureAudio(playerEl);
    var rect = track.getBoundingClientRect();
    var pct = (rect.right - clientX) / rect.width;
    pct = Math.max(0, Math.min(1, pct));
    voiceUpdateProgress(playerEl, pct);
    if (audio.duration && audio.duration !== Infinity) {
      audio.currentTime = pct * audio.duration;
      voiceUpdateTime(playerEl, audio.currentTime);
    }
  }

  function handleVoicePlay(playBtn) {
    var playerEl = playBtn.closest('.pltx2-voice');
    if (!playerEl) return;
    var audio = voiceEnsureAudio(playerEl);

    if (audio.paused) {
      if (activeAudio && activeAudio !== audio) {
        activeAudio.pause();
        if (activePlayer) activePlayer.classList.remove('pltx2-voice--playing');
      }
      playerEl._voiceLoading = true;
      voiceSetState(playerEl, 'loading');
      audio.play().catch(function(err) {
        playerEl._voiceLoading = false;
        voiceSetState(playerEl, 'paused');
        console.error('[pltx2-voice] Play failed:', err);
      });
      activeAudio = audio;
      activePlayer = playerEl;
    } else {
      audio.pause();
      playerEl._voiceLoading = false;
      voiceSetState(playerEl, 'paused');
      activeAudio = null;
      activePlayer = null;
    }
  }

  function stopActiveAudio() {
    if (activeAudio) {
      activeAudio.pause();
      activeAudio.currentTime = 0;
      activeAudio = null;
    }
    if (activePlayer) {
      activePlayer.classList.remove('pltx2-voice--playing', 'pltx2-voice--loading');
      activePlayer = null;
    }
  }

  /* === Cleanup before list replacement === */
  function cleanupCards() {
    stopActiveAudio();
    activeDragPlayer = null;
    if (cardObserver) { cardObserver.disconnect(); cardObserver = null; }
    if (loadMoreObserver) { loadMoreObserver.disconnect(); loadMoreObserver = null; }
    if (listEl) {
      listEl.querySelectorAll('.pltx2-voice').forEach(function(p) {
        if (p._audio) {
          p._audio.pause();
          try { p._audio.src = ''; } catch (e) {}
          p._audio = null;
        }
      });
    }
    reviewById = {};
  }

  /* === Thumbs (synced across card + modal instances of a review) === */
  function toggleThumb(btn) {
    var emoji = btn.getAttribute('data-emoji');
    var reviewId = btn.getAttribute('data-review-id');
    if (!reviewId) return;
    var isActive = btn.classList.contains('pltx2-card__thumb--active');
    var opposite = emoji === '👍' ? '👎' : '👍';

    var sameBtns = section.querySelectorAll('.pltx2-card__thumb[data-review-id="' + reviewId + '"][data-emoji="' + emoji + '"]');
    var oppBtns = section.querySelectorAll('.pltx2-card__thumb[data-review-id="' + reviewId + '"][data-emoji="' + opposite + '"]');

    /* mutual exclusion */
    var oppWasActive = oppBtns.length && oppBtns[0].classList.contains('pltx2-card__thumb--active');
    if (oppWasActive) {
      oppBtns.forEach(function(ob) {
        ob.classList.remove('pltx2-card__thumb--active');
        var oc = ob.querySelector('.pltx2-card__thumb-count');
        if (oc) oc.textContent = Math.max(0, (parseInt(oc.textContent) || 0) - 1);
      });
      sendReaction(reviewId, opposite);
    }

    sameBtns.forEach(function(sb) {
      var countSpan = sb.querySelector('.pltx2-card__thumb-count');
      var count = countSpan ? (parseInt(countSpan.textContent) || 0) : 0;
      if (isActive) {
        sb.classList.remove('pltx2-card__thumb--active');
        if (countSpan) countSpan.textContent = Math.max(0, count - 1);
      } else {
        sb.classList.add('pltx2-card__thumb--active');
        if (countSpan) countSpan.textContent = count + 1;
        sb.classList.add('pltx2-card__thumb--bounce');
        setTimeout(function() { sb.classList.remove('pltx2-card__thumb--bounce'); }, 200);
      }
    });

    sendReaction(reviewId, emoji);
  }

  function sendReaction(reviewId, emoji) {
    if (!apiBase || !reviewId) return;
    fetch(apiBase + '/api/reviews/' + reviewId + '/react', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ emoji: emoji, fingerprint: getFingerprint() })
    }).catch(function(err) { console.error('[pltx2] react error:', err); });
  }

  /* === Review detail modal === */
  var modalPhotos = [];
  var modalIdx = 0;
  var modalOpener = null;
  var scrollLockPad = 0;

  function lockScroll() {
    scrollLockPad = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollLockPad > 0) document.body.style.paddingRight = scrollLockPad + 'px';
  }
  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function updateModalPhoto() {
    if (!modalPhotos.length) return;
    rmodalImg.src = modalPhotos[modalIdx];
    rmodalCounter.textContent = (modalIdx + 1) + '/' + modalPhotos.length;
  }

  function openReview(reviewId, openerEl) {
    var r = reviewById[reviewId] || mustById[reviewId];
    if (!r || !rmodal) return;
    modalOpener = openerEl || null;

    var name = r.reviewerName || r.name || pltxT('pltx2.js.k011', 'אנונימי');
    rmodalName.textContent = name;
    rmodalVerified.style.display = r.isVerifiedPurchase ? '' : 'none';
    rmodalStars.innerHTML = starsHtml(r.rating, 16);
    rmodalStars.setAttribute('aria-label', r.rating + pltxT('pltx2.js.k004', ' מתוך 5 כוכבים'));
    rmodalDate.textContent = fmtDate(r);

    rmodalBody.innerHTML = bodyHtml(r) + voicesHtml(r) + thumbsHtml(r) + replyHtml(r);

    /* mirror thumb active states from the list card */
    var card = listEl.querySelector('.pltx2-card[data-review-id="' + reviewId + '"]');
    if (card) {
      card.querySelectorAll('.pltx2-card__thumb--active').forEach(function(activeBtn) {
        var emoji = activeBtn.getAttribute('data-emoji');
        var target = rmodalBody.querySelector('.pltx2-card__thumb[data-emoji="' + emoji + '"]');
        if (target) {
          target.classList.add('pltx2-card__thumb--active');
          var src = activeBtn.querySelector('.pltx2-card__thumb-count');
          var dst = target.querySelector('.pltx2-card__thumb-count');
          if (src && dst) dst.textContent = src.textContent;
        }
      });
    }

    /* product chip + view button */
    var p = group.products[String(r._pid)] || group.products[String(currentProductId)];
    rmodalProduct.innerHTML = p
      ? (p.image ? '<img class="pltx2-rmodal__product-img" src="' + esc(p.image) + '" alt="" width="56" height="56">' : '') +
        '<div class="pltx2-rmodal__product-details">' +
          '<div class="pltx2-rmodal__product-title">' + esc(p.title) + '</div>' +
          colorLine(p, 'pltx2-rmodal__product-color') +
          '<a class="pltx2-rmodal__product-btn" href="' + esc(p.url) + '"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><use href="#pltx2-bag"/></svg>' + pltxT('pltx2.js.k079', 'צפייה במוצר') + '</a>' +
        '</div>'
      : '';

    modalPhotos = (r.photos || []).slice();
    modalIdx = 0;
    rmodal.classList.toggle('pltx2-rmodal--noimg', modalPhotos.length === 0);
    rmodal.classList.toggle('pltx2-rmodal--multi', modalPhotos.length > 1);
    if (modalPhotos.length) updateModalPhoto();
    else rmodalImg.removeAttribute('src');

    rmodal.hidden = false;
    lockScroll();
    var closeBtn = rmodal.querySelector('.pltx2-rmodal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeReview() {
    if (!rmodal || rmodal.hidden) return;
    /* stop audio if the playing instance lives inside the modal */
    if (activePlayer && rmodal.contains(activePlayer)) stopActiveAudio();
    rmodalBody.querySelectorAll('.pltx2-voice').forEach(function(pl) {
      if (pl._audio) {
        pl._audio.pause();
        try { pl._audio.src = ''; } catch (e) {}
        pl._audio = null;
      }
    });
    rmodal.hidden = true;
    unlockScroll();
    if (modalOpener && modalOpener.focus) modalOpener.focus();
    modalOpener = null;
  }

  /* === Review photo protection ===
     Review photos are customers' own pictures — no long-press "Save image" (iOS: CSS
     touch-callout, Android/desktop: contextmenu), no drag-out, no copy, no selection.
     The <img> in cards and the popup also ignores the pointer, so the press lands on the
     frame, not the image. This raises the bar; DevTools / network tab / screenshots
     cannot be blocked by any website. */
  ['contextmenu', 'dragstart', 'copy', 'cut', 'selectstart'].forEach(function(type) {
    document.addEventListener(type, function(e) {
      if (e.target && e.target.closest && e.target.closest('.pltx2-protect')) e.preventDefault();
    }, true);
  });

  /* === Lightbox (zoom from modal media) === */
  var lbPhotos = [];
  var lbIndex = 0;
  var lbOverlay = document.getElementById('pltx2Lightbox');
  var lbImg = document.getElementById('pltx2LbImg');
  var lbCounter = document.getElementById('pltx2LbCounter');

  function openLightboxArr(photos, idx) {
    if (!photos || !photos.length || !lbOverlay) return;
    lbPhotos = photos.slice();
    lbIndex = idx || 0;
    lbImg.src = lbPhotos[lbIndex];
    lbOverlay.classList.add('pltx2-vertical__lightbox--open');
    updateLightbox();
  }

  function closeLightbox() {
    lbOverlay.classList.remove('pltx2-vertical__lightbox--open');
  }

  function updateLightbox() {
    var multi = lbPhotos.length > 1;
    document.getElementById('pltx2LbPrev').style.display = multi ? '' : 'none';
    document.getElementById('pltx2LbNext').style.display = multi ? '' : 'none';
    lbCounter.style.display = multi ? '' : 'none';
    if (multi) lbCounter.textContent = (lbIndex + 1) + '/' + lbPhotos.length;
  }

  if (lbOverlay) {
    lbOverlay.querySelector('.pltx2-vertical__lightbox-close').addEventListener('click', closeLightbox);
    lbOverlay.addEventListener('click', function(e) {
      if (e.target === lbOverlay) closeLightbox();
    });
    document.getElementById('pltx2LbPrev').addEventListener('click', function() {
      lbIndex = (lbIndex + 1) % lbPhotos.length;
      lbImg.src = lbPhotos[lbIndex];
      updateLightbox();
    });
    document.getElementById('pltx2LbNext').addEventListener('click', function() {
      lbIndex = (lbIndex - 1 + lbPhotos.length) % lbPhotos.length;
      lbImg.src = lbPhotos[lbIndex];
      updateLightbox();
    });
  }

  /* === Single delegated click listener for the whole section === */
  section.addEventListener('click', function(e) {
    var playBtn = e.target.closest('.pltx2-voice__play');
    if (playBtn) { handleVoicePlay(playBtn); return; }

    var thumb = e.target.closest('.pltx2-card__thumb');
    if (thumb) { toggleThumb(thumb); return; }

    if (e.target.closest('a.pltx2-card__product') || e.target.closest('a.pltx2-rmodal__product-btn')) {
      return; /* native navigation */
    }

    if (e.target.closest('[data-rmodal-close]')) { closeReview(); return; }

    if (e.target.closest('#pltx2RmodalPrev')) {
      modalIdx = (modalIdx + 1) % modalPhotos.length;
      updateModalPhoto();
      return;
    }
    if (e.target.closest('#pltx2RmodalNext')) {
      modalIdx = (modalIdx - 1 + modalPhotos.length) % modalPhotos.length;
      updateModalPhoto();
      return;
    }
    if (e.target.closest('.pltx2-rmodal__img, .pltx2-rmodal__media')) { // the img itself has pointer-events:none (photo protection)
      openLightboxArr(modalPhotos, modalIdx);
      return;
    }
    if (e.target.closest('.pltx2-voice__track')) return;

    var card = e.target.closest('.pltx2-card');
    if (card && listEl.contains(card)) {
      var id = card.getAttribute('data-review-id');
      if (id) openReview(id, card.querySelector('.pltx2-card__open') || card);
    }
  });

  /* Keyboard: Enter/Space on the reviewer-name button (real button → click fires) */

  /* Waveform drag start — delegated (covers list + modal) */
  section.addEventListener('mousedown', function(e) {
    var track = e.target.closest('.pltx2-voice__track');
    if (!track) return;
    var playerEl = track.closest('.pltx2-voice');
    if (!playerEl) return;
    activeDragPlayer = playerEl;
    voiceSeekFromX(playerEl, e.clientX);
    e.preventDefault();
  });
  section.addEventListener('touchstart', function(e) {
    var track = e.target.closest('.pltx2-voice__track');
    if (!track) return;
    var playerEl = track.closest('.pltx2-voice');
    if (!playerEl) return;
    activeDragPlayer = playerEl;
    voiceSeekFromX(playerEl, e.touches[0].clientX);
    e.preventDefault();
    e.stopPropagation();
  }, { passive: false });

  document.addEventListener('mousemove', function(e) {
    if (!activeDragPlayer) return;
    voiceSeekFromX(activeDragPlayer, e.clientX);
  });
  document.addEventListener('mouseup', function() {
    activeDragPlayer = null;
  });
  document.addEventListener('touchmove', function(e) {
    if (!activeDragPlayer) return;
    voiceSeekFromX(activeDragPlayer, e.touches[0].clientX);
    e.preventDefault();
    e.stopPropagation();
  }, { passive: false });
  document.addEventListener('touchend', function() {
    activeDragPlayer = null;
  });

  /* === Escape key: lightbox → modal → panels (one layer per press) === */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (lbOverlay && lbOverlay.classList.contains('pltx2-vertical__lightbox--open')) { closeLightbox(); return; }
      if (rmodal && !rmodal.hidden) { closeReview(); return; }
      if (headerEl && headerEl.classList.contains('pltx2-vertical__header--dist-open')) setDistOpen(false);
      if (sortWrap && sortWrap.classList.contains('pltx2-vertical__menu--open')) setMenuOpen(false);
      return;
    }
    if (!lbOverlay || !lbOverlay.classList.contains('pltx2-vertical__lightbox--open')) return;
    if (e.key === 'ArrowLeft') { lbIndex = (lbIndex + 1) % lbPhotos.length; lbImg.src = lbPhotos[lbIndex]; updateLightbox(); }
    else if (e.key === 'ArrowRight') { lbIndex = (lbIndex - 1 + lbPhotos.length) % lbPhotos.length; lbImg.src = lbPhotos[lbIndex]; updateLightbox(); }
  });

  /* === Load more === */
  if (loadBtn) {
    loadBtn.addEventListener('click', function() {
      loadBtn.disabled = true;
      loadBtn.classList.add('pltx2-vertical__load-btn--loading');
      loadPage(true).then(function() {
        loadBtn.disabled = false;
        loadBtn.classList.remove('pltx2-vertical__load-btn--loading');
      });
    });
  }

  /* === Distribution panel toggle + rating-row filters === */
  function setDistOpen(open) {
    headerEl.classList.toggle('pltx2-vertical__header--dist-open', open);
    if (distToggle) distToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (distToggle) {
    distToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      setMenuOpen(false);
      setDistOpen(!headerEl.classList.contains('pltx2-vertical__header--dist-open'));
    });
  }
  if (distRowsEl) {
    distRowsEl.addEventListener('click', function(e) {
      var row = e.target.closest('.pltx2-vertical__dist-row');
      if (!row || row.hasAttribute('disabled')) return;
      var starVal = parseInt(row.getAttribute('data-stars'), 10);
      var filterKey = starVal + 'star';
      var isActive = row.classList.contains('pltx2-vertical__dist-row--active');
      distRowsEl.querySelectorAll('.pltx2-vertical__dist-row').forEach(function(rw) {
        rw.classList.remove('pltx2-vertical__dist-row--active');
        rw.setAttribute('aria-pressed', 'false');
      });
      if (isActive) {
        state.filter = 'all';
      } else {
        row.classList.add('pltx2-vertical__dist-row--active');
        row.setAttribute('aria-pressed', 'true');
        state.filter = filterKey;
      }
      syncDropdownActives();
      loadPage(false);
    });
  }

  /* === Sort/filter dropdown === */
  function setMenuOpen(open) {
    sortWrap.classList.toggle('pltx2-vertical__menu--open', open);
    if (sortBtn) sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function syncDropdownActives() {
    if (!sortMenu) return;
    sortMenu.querySelectorAll('[data-sort]').forEach(function(o) {
      o.classList.toggle('pltx2-vertical__dropdown-opt--active', o.getAttribute('data-sort') === state.sort);
    });
    var mediaFilter = (state.filter === 'photo' || state.filter === 'voice') ? state.filter : (state.filter === 'all' ? 'all' : null);
    sortMenu.querySelectorAll('[data-filter]').forEach(function(o) {
      o.classList.toggle('pltx2-vertical__dropdown-opt--active', o.getAttribute('data-filter') === mediaFilter);
    });
  }
  if (sortBtn) {
    sortBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      setDistOpen(false);
      setMenuOpen(!sortWrap.classList.contains('pltx2-vertical__menu--open'));
    });
  }
  if (sortMenu) {
    sortMenu.addEventListener('click', function(e) {
      var opt = e.target.closest('.pltx2-vertical__dropdown-opt');
      if (!opt) return;
      e.stopPropagation();
      if (opt.hasAttribute('data-sort')) {
        state.sort = opt.getAttribute('data-sort') || 'newest';
      } else if (opt.hasAttribute('data-filter')) {
        state.filter = opt.getAttribute('data-filter') || 'all';
        /* media filter replaces any rating filter */
        distRowsEl.querySelectorAll('.pltx2-vertical__dist-row').forEach(function(rw) {
          rw.classList.remove('pltx2-vertical__dist-row--active');
          rw.setAttribute('aria-pressed', 'false');
        });
      }
      syncDropdownActives();
      setMenuOpen(false);
      loadPage(false);
    });
  }
  document.addEventListener('click', function(e) {
    if (sortWrap && !sortWrap.contains(e.target)) setMenuOpen(false);
    if (headerEl && distToggle && distPanel &&
        !distToggle.contains(e.target) && !distPanel.contains(e.target)) setDistOpen(false);
  });

  /* === "Must read before you buy" — pinned reviews carousel ===
     One card at a time, endless swipe (Pltx2Flick, assets/pltx2-flick.js). Shows the
     reviews pinned in the admin panel; while it is on screen those reviews are kept out
     of the default feed (newest / all), so the page reads "the best ones, then the rest".
     Section setting toggles it and picks mobile-only or everywhere. Needs >= 3 pins. */
  var mustEl = document.getElementById('pltx2Must');
  var mustTrack = document.getElementById('pltx2MustTrack');
  var mustIds = {};
  var mustOn = false;

  function mustWanted() {
    if (!mustEl || !mustTrack || typeof window.Pltx2Flick !== 'function' || !apiBase) return false;
    if (mustEl.classList.contains('pltx2-must--mobile') && !window.matchMedia('(max-width: 749px)').matches) return false;
    return true;
  }

  function mustCardHtml(r) {
    var name = esc(r.reviewerName || r.name || pltxT('pltx2.js.k011', 'אנונימי'));
    var initial = esc((r.reviewerName || r.name || '?').trim().charAt(0));
    /* many imported titles are just the first words of the body — skip the echo */
    var norm = function(x) { return String(x || '').replace(/==/g, '').replace(/[^p{L}p{N}]+/gu, ''); };
    var showTitle = !!r.title && norm(r.body).indexOf(norm(r.title).slice(0, 40)) !== 0;
    var photo = (r.photos && r.photos.length)
      ? '<div class="pltx2-must__photo pltx2-protect"><img draggable="false" src="' + esc(r.photos[0]) + '" alt="" loading="lazy" decoding="async"></div>'
      : '';
    var verified = r.isVerifiedPurchase
      ? '<svg class="pltx2-must__verified" width="14" height="14" viewBox="0 0 22 22" role="img" aria-label="' + pltxT('pltx2.js.k046', 'מאומת') + '"><use href="#pltx2-verified-cc"/></svg>'
      : '';
    return '<div class="pltx2-must__cell" data-review-id="' + esc(r.id) + '">' +
      '<article class="pltx2-must__card">' +
        '<div class="pltx2-must__top">' +
          '<div class="pltx2-must__stars" role="img" aria-label="' + r.rating + pltxT('pltx2.js.k004', ' מתוך 5 כוכבים') + '">' + starsHtml(r.rating, 15) + '</div>' +
          '<span class="pltx2-must__badge"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><use href="#pltx2-pin"/></svg>' + esc(mustTrack.getAttribute('data-pinned-label') || '') + '</span>' +
        '</div>' +
        (showTitle ? '<div class="pltx2-must__rtitle" dir="auto">' + esc(r.title) + '</div>' : '') +
        '<div class="pltx2-must__content">' +
          '<div class="pltx2-must__text" dir="auto">' + bodyHtml(r) + '</div>' + photo +
        '</div>' +
        '<div class="pltx2-must__foot">' +
          '<span class="pltx2-must__who"><span class="pltx2-must__avatar" aria-hidden="true">' + initial + '</span><span class="pltx2-must__name">' + name + '</span>' + verified + '</span>' +
          '<span class="pltx2-must__more">' + esc(mustTrack.getAttribute('data-more-label') || '') + '</span>' +
        '</div>' +
      '</article>' +
    '</div>';
  }

  function fetchPinned() {
    var max = parseInt(section.getAttribute('data-must-max') || '10', 10) || 10;
    return Promise.all(group.ids.map(function(id) {
      return fetch(apiBase + '/api/reviews/product/' + id + '?limit=20&sort=newest')
        .then(function(res) { return res.json(); })
        .then(function(d) {
          return ((d && d.reviews) || []).filter(function(r) { return r.isPinned; })
            .map(function(r) { r._pid = id; return r; });
        })
        .catch(function() { return []; });
    })).then(function(lists) {
      var all = [].concat.apply([], lists);
      /* photos first, then rating, then newest */
      all.sort(function(a, b) {
        var pa = (a.photos && a.photos.length) ? 1 : 0, pb = (b.photos && b.photos.length) ? 1 : 0;
        if (pa !== pb) return pb - pa;
        if (a.rating !== b.rating) return b.rating - a.rating;
        return sortKeyDate(b) > sortKeyDate(a) ? 1 : -1;
      });
      return all.slice(0, max);
    });
  }

  function initMust() {
    return fetchPinned().then(function(reviews) {
      if (reviews.length < 3) return; /* too few to loop — the feed shows them first anyway */
      mustTrack.innerHTML = reviews.map(mustCardHtml).join('');
      reviews.forEach(function(r) { mustById[r.id] = r; mustIds[r.id] = true; });
      mustEl.hidden = false;
      mustOn = true;

      var counter = document.getElementById('pltx2MustCounter');
      var dotsEl = document.getElementById('pltx2MustDots');
      if (dotsEl) dotsEl.innerHTML = reviews.map(function() { return '<i></i>'; }).join('');
      var flick = null;
      function onChange() {
        if (!flick) return;
        var i = flick.selectedIndex;
        if (counter) counter.textContent = (i + 1) + '/' + reviews.length;
        if (dotsEl) for (var d = 0; d < dotsEl.children.length; d++) dotsEl.children[d].classList.toggle('is-on', d === i);
      }
      var rtl = (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
      flick = new window.Pltx2Flick(mustTrack, {
        rightToLeft: rtl,
        onChange: onChange,
        onStaticClick: function(i) {
          if (i !== flick.selectedIndex) { flick.select(i); return; }
          openReview(flick.cells[i].getAttribute('data-review-id'), mustTrack);
        }
      });
      onChange();

      /* equal-height cards: the tallest card sets the strip height */
      function equalize() {
        var cells = flick.cells, max = 0, i;
        for (i = 0; i < cells.length; i++) cells[i].style.height = '';
        for (i = 0; i < cells.length; i++) max = Math.max(max, cells[i].offsetHeight);
        for (i = 0; i < cells.length; i++) cells[i].style.height = max + 'px';
        flick.resize();
      }
      equalize();
      /* photos are lazy so they do not load with the page; once the carousel nears the
         screen, fetch all of them so off-screen cards are ready before they are swiped in */
      if ('IntersectionObserver' in window) {
        var mustImgIo = new IntersectionObserver(function(entries) {
          if (!entries[entries.length - 1].isIntersecting) return;
          mustTrack.querySelectorAll('img[loading="lazy"]').forEach(function(im) { im.loading = 'eager'; });
          mustImgIo.disconnect();
        }, { rootMargin: '400px 0px' });
        mustImgIo.observe(mustEl);
      }
      var t = null;
      window.addEventListener('resize', function() { clearTimeout(t); t = setTimeout(equalize, 150); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalize);

      mustTrack.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && e.target === mustTrack) openReview(flick.cells[flick.selectedIndex].getAttribute('data-review-id'), mustTrack);
      });

      /* the feed may have rendered first (slow API) — drop the duplicates now */
      if (state.sort === 'newest' && state.filter === 'all') {
        Object.keys(mustIds).forEach(function(id) {
          var dup = listEl.querySelector('.pltx2-card[data-review-id="' + id + '"]');
          if (dup) dup.remove();
        });
      }
    }).catch(function(err) { console.warn('[pltx2-vertical] must-read carousel skipped:', err); });
  }

  /* === Tap a review in the slider under the product title → glide to the reviews ===
     The slider is the shared "recommand-info" block (also on pages without reviews), so the
     handler lives here: it only exists where this feed exists. A swipe on that slider is
     not a tap. Custom eased scroll (not the theme's CSS smooth scroll) that re-aims every
     frame, so lazy images / reveal animations loading on the way can't make it land short
     or feel stuck. Lands on the summary ("והתוצאה?") when the page has one. */
  function glideToReviews() {
    var target = document.querySelector('.pltx2-summary') || section;
    var headerEl2 = document.querySelector('sticky-header, .shopify-section-header-sticky');
    function aim() {
      var off = headerEl2 ? Math.max(0, headerEl2.getBoundingClientRect().bottom) : 0;
      return Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - off - 12);
    }
    var html = document.documentElement;
    var prevBehavior = html.style.scrollBehavior;
    var startY = window.pageYOffset;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dist = Math.abs(aim() - startY);
    var dur = reduce ? 0 : Math.min(950, Math.max(420, dist * 0.09));
    var t0 = null;
    var cancelled = false;
    function cancel() { cancelled = true; }
    window.addEventListener('wheel', cancel, { passive: true, once: true });
    window.addEventListener('touchstart', cancel, { passive: true, once: true });
    html.style.scrollBehavior = 'auto';
    function done() {
      html.style.scrollBehavior = prevBehavior;
      window.removeEventListener('wheel', cancel);
      window.removeEventListener('touchstart', cancel);
    }
    if (!dur) { window.scrollTo(0, aim()); done(); return; }
    function step(ts) {
      if (cancelled) { done(); return; }
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; /* easeInOutCubic */
      window.scrollTo(0, startY + (aim() - startY) * e);
      if (p < 1) requestAnimationFrame(step);
      else { window.scrollTo(0, aim()); done(); }
    }
    requestAnimationFrame(step);
  }

  (function bindReviewTeaser() {
    var SEL = '.splide__slide__container > [class^="pltx-review-item-"]';
    if (!document.querySelector(SEL)) return;
    var downX = 0, downY = 0;
    document.addEventListener('pointerdown', function(e) { downX = e.clientX; downY = e.clientY; }, true);
    document.addEventListener('click', function(e) {
      var item = e.target.closest && e.target.closest(SEL);
      if (!item || e.target.closest('a, button')) return;
      if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) return; /* it was a swipe */
      glideToReviews();
    });
    document.querySelectorAll(SEL).forEach(function(el) {
      el.classList.add('pltx2-teaser-link');
      el.setAttribute('role', 'link');
      el.tabIndex = 0;
      el.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); glideToReviews(); }
      });
    });
  })();

  /* === Init === */
  window.__pltx2v3 = function() {
    return {
      loading: state.loading, sort: state.sort, filter: state.filter,
      sources: sources.map(function(s) { return { id: s.id, buf: s.buffer.length, done: s.done, cursor: !!s.cursor }; }),
      hl: function(s) { return bodyHtml({ body: s }); }
    };
  };
  fetchSummaries();
  /* pinned carousel first (max 3 s) so the feed can leave those reviews out */
  var mustReady = mustWanted()
    ? Promise.race([initMust(), new Promise(function(r) { setTimeout(r, 3000); })])
    : Promise.resolve();
  mustReady.then(function() { loadPage(false); });
})();
